import { Component, OnInit, Input, ViewChild, QueryList, ViewChildren, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, UntypedFormControl, Validators, UntypedFormBuilder, FormGroupDirective } from '@angular/forms';
import { getMotorrad, getExpertMode, toggleEditMode } from '../../../../shared/utils';
import { ActivatedRoute } from '@angular/router';
import { IKfzResult } from '../../../models/kfzresult';
import { merge, ReplaySubject, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { VersicherungsbestaetigungComponent } from '../../versicherungsbestaetigung/versicherungsbestaetigung.component';
import { ILdstellenResult, ILookupValue } from '../../../models/lookupvalues';
import { DateService } from '../../../service/date.service';
import { LookupService } from '../../../service/lookup.service';
import { DatepickerService } from '../../../service/datepicker.service';
import { LookupGroup } from '../../../../shared/autocomplete';
import { RisikoKfzComponent } from '../../calculatekfz/risikokfz/risikokfz.component';
import { KaskoKfzComponent } from '../../calculatekfz/kaskokfz/kaskokfz.component';
import { VorversicherungComponent } from '../../vorversicherung/vorversicherung.component';
import { IKfzAntrag } from '../../../models/kfzantrag';
import * as moment from 'moment';
import { CustomValidator } from '../../../../shared/validation';
import { PopupService } from 'src/app/service/popup.service';

@Component({
  selector: 'app-kfz-antrag',
  templateUrl: './kfz-antrag.component.html',
  styleUrls: ['./kfz-antrag.component.scss']
})
export class KfzAntragComponent implements OnInit, OnChanges {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  versicherungssummeVariante: ILookupValue;

  @Input()
  bmStufeVerband: ILookupValue;

  @Input()
  bmStufe: ILookupValue;

  @Input()
  showBmStufeVerband: boolean;

  @Input()
  showBmStufe: boolean;

  @Input()
  risikos: UntypedFormArray;

  @Input()
  kaskos: UntypedFormArray;

  @Input()
  insassenVariante: ILookupValue;

  @Input()
  lenkerVariante: ILookupValue;

  @Input()
  selected = false;

  @Input()
  beginndatum: UntypedFormControl;

  @Input()
  region: ILookupValue;

  @Input()
  kfzResult: IKfzResult;

  @Input()
  privatperson: boolean;

  @Input()
  ldstellen: ReplaySubject<ILdstellenResult>;

  @Input()
  _kaskoKfzComponents: QueryList<KaskoKfzComponent>;

  schadenZeitpunktMinDate = new Date();
  schadenZeitpunktMaxDate: Date;


  bmStufenVorversicherung: Map<number, string> =
    new Map([
      [0, '00'],
      [1, '01'],
      [2, '02'],
      [3, '03'],
      [4, '04'],
      [5, '05'],
      [6, '06'],
      [7, '07'],
      [8, '08'],
      [9, '09']
    ]);

  expertMode: boolean;
  motorrad: boolean;
  versicherungGroupOptions: Observable<LookupGroup[]>;
  versicherungSonstigesGroupOptions: Observable<LookupGroup[]>;

  @ViewChild(VersicherungsbestaetigungComponent) versicherungsbestaetigungComponent: VersicherungsbestaetigungComponent;
  @ViewChild('_vorversicherung') vorversicherungComponent: VorversicherungComponent;
  @ViewChild('_kaskoVorversicherung') kaskoVorversicherungComponent: VorversicherungComponent;
  @ViewChildren(RisikoKfzComponent) risikoKfzComponents: QueryList<RisikoKfzComponent>;
  @ViewChildren(KaskoKfzComponent) kaskoKfzComponents: QueryList<KaskoKfzComponent>;

  constructor(private route: ActivatedRoute, public dateService: DateService, public translateService: TranslateService,
    public lookupService: LookupService, public datepickerService: DatepickerService, private ref: ChangeDetectorRef, private popupService: PopupService) {
    this.expertMode = getExpertMode(this.route);
    this.motorrad = getMotorrad(this.route);
    this.schadenZeitpunktMaxDate = new Date(Date.UTC(dateService.today().getFullYear(), dateService.today().getMonth(), dateService.today().getDate()-1));

  }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      vb: VersicherungsbestaetigungComponent.createFormGroup(fb),
      kennzeichen: new UntypedFormControl('', CustomValidator.validateKennzeichen),
      kaskoVorversicherung: new UntypedFormControl(''),
      kaskoVorversicherungGroup: VorversicherungComponent.createFormGroup(fb),
      kaskoStornodatumVorvertrag: new UntypedFormControl(''),
      kaskoschaeden: new UntypedFormControl(''),
      kaskoschaedenAnzahl: new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      hdiKfzMotorradVersicherung: new UntypedFormControl('', Validators.required),
      hdiPolizzennummer: new UntypedFormControl(''),
      hdiKfzMotorradVersicherungGroup: fb.group({
        vorversicherungGroup: VorversicherungComponent.createFormGroup(fb),
        bmStufeVorversicherung: new UntypedFormControl(''),
        bmStufeNullJahre: new UntypedFormControl('', [Validators.pattern('^[0-9]*$')]),
        offeneSchaeden: new UntypedFormControl(''),
        schaedenZeitpunktGroup: fb.group({
          firstSchadenZeitpunkt: new UntypedFormControl('', Validators.required),
          secondSchadenZeitpunkt: new UntypedFormControl(''),
          thirdSchadenZeitpunkt: new UntypedFormControl('')
        }),
        stornodatumVorvertrag: new UntypedFormControl('')
      })
    });
  }

  ngOnInit(): void {
    this.onValueChanged();
    this.toggleEditMode();
  }

  ngOnChanges(changes: SimpleChanges) {
    // this seems never be fired if completed is true
    if (changes.selected && changes.selected.previousValue === false && changes.selected.currentValue === true) {
      this.toggleEditMode();
    }
  }

  get vb() { return this.formGroup.get('vb'); }
  get kennzeichen() { return this.formGroup.get('kennzeichen'); }

  get kaskoVorversicherung() { return this.formGroup.get('kaskoVorversicherung'); }
  get kaskoVorversicherungGroup() { return this.formGroup.get('kaskoVorversicherungGroup'); }
  get kaskoStornodatumVorvertrag() { return this.formGroup.get('kaskoStornodatumVorvertrag'); }
  get kaskoschaeden() { return this.formGroup.get('kaskoschaeden'); }
  get kaskoschaedenAnzahl() { return this.formGroup.get('kaskoschaedenAnzahl'); }
  get hdiKfzMotorradVersicherung() { return this.formGroup.get('hdiKfzMotorradVersicherung'); }
  get hdiPolizzennummer() { return this.formGroup.get('hdiPolizzennummer'); }

  get hdiKfzMotorradVersicherungGroup() { return this.formGroup.get('hdiKfzMotorradVersicherungGroup'); }
  get vorversicherungGroup() { return this.hdiKfzMotorradVersicherungGroup.get('vorversicherungGroup'); }
  get stornodatumVorvertrag() { return this.hdiKfzMotorradVersicherungGroup.get('stornodatumVorvertrag'); }
  get bmStufeVorversicherung() { return this.hdiKfzMotorradVersicherungGroup.get('bmStufeVorversicherung'); }
  get bmStufeNullJahre() { return this.hdiKfzMotorradVersicherungGroup.get('bmStufeNullJahre'); }
  get offeneSchaeden() { return this.hdiKfzMotorradVersicherungGroup.get('offeneSchaeden'); }
  get schaedenZeitpunktGroup() { return this.hdiKfzMotorradVersicherungGroup.get('schaedenZeitpunktGroup'); }

  get firstSchadenZeitpunkt() { return this.schaedenZeitpunktGroup.get('firstSchadenZeitpunkt'); }
  get secondSchadenZeitpunkt() { return this.schaedenZeitpunktGroup.get('secondSchadenZeitpunkt'); }
  get thirdSchadenZeitpunkt() { return this.schaedenZeitpunktGroup.get('thirdSchadenZeitpunkt'); }

  toggleEditMode(): void {
    toggleEditMode(this.hdiKfzMotorradVersicherung, this.showHdiKfzMotorradVersicherung);
    toggleEditMode(this.hdiPolizzennummer, this.showHdiPolizzennummer);
    toggleEditMode(this.bmStufeVorversicherung, this.showBmStufeVorversicherung);
    toggleEditMode(this.bmStufeNullJahre, this.showBmStufeNullJahre);
    toggleEditMode(this.offeneSchaeden, this.showOffeneSchaeden);
    toggleEditMode(this.firstSchadenZeitpunkt, this.showSchadenZeitpunkte);
    toggleEditMode(this.secondSchadenZeitpunkt, this.showSchadenZeitpunkte);
    toggleEditMode(this.thirdSchadenZeitpunkt, this.showSchadenZeitpunkte);
    toggleEditMode(this.stornodatumVorvertrag, this.showStornodatumVorvertrag);
    toggleEditMode(this.kaskoschaeden, this.showKaskoschaeden);
    toggleEditMode(this.kaskoschaedenAnzahl, this.showKaskoschaedenAnzahl);
    toggleEditMode(this.kaskoStornodatumVorvertrag, this.showKaskoStornodatumVorvertrag);
  }

  get interesseKaskoversicherung() {
    return this.kaskoKfzComponents?.some(k => k.interesseKaskoversicherung);
  }

  get showHdiKfzMotorradVersicherung() {
    return this.motorrad || this.risikoKfzComponents?.some(x => x.fahrzeugart.value?.Key === '15' ||
      x.fahrzeugart.value?.Key === '6' || x.fahrzeugart.value?.Key === '22') ? true : false;
  }

  get showHdiPolizzennummer() {
    return this.hdiKfzMotorradVersicherung.value === '1' ? true : false;
  }

  get showHdiKfzMotorradVersicherungGroup() {
    return this.hdiKfzMotorradVersicherung.value === '2' ? true : false;
  }

  get showBmStufeVorversicherung() {
    return this.showHdiKfzMotorradVersicherungGroup && !this.motorrad && this.risikoKfzComponents?.some(x => x.fahrzeugart.value?.Key === '15' ||
      x.fahrzeugart.value?.Key === '6' || x.fahrzeugart.value?.Key === '22') ? true : false;
  }

  get showBmStufeNullJahre() {
    return this.showBmStufeVorversicherung && this.bmStufeVorversicherung.value === 0 ? true : false;
  }

  get showOffeneSchaeden() {
    return this.showHdiKfzMotorradVersicherungGroup && !this.motorrad && this.bmStufeVorversicherung.value !== 10 ? true : false;
  }

  get showSchadenZeitpunkte() {
    return this.offeneSchaeden.value === 'ja' ? true : false;
  }

  get showStornodatumVorvertrag() {
    return this.showHdiKfzMotorradVersicherungGroup && this.bmStufeVorversicherung.value !== 10 ? true : false;
  }

  get showKaskoVorversicherung() {
    return this.kaskoKfzComponents?.some(x => x.interesseKaskoversicherung) ? true : false;
  }

  get showKaskoVorversicherungGroup() {
    return this.showKaskoVorversicherung && this.kaskoVorversicherung.value === '2' ? true : false;
  }

  get showKaskoStornodatumVorvertrag() {
    return this.showKaskoVorversicherungGroup ? true : false;
  }

  get showKaskoschaeden() {
    return this.showKaskoVorversicherung && (this.kaskoVorversicherung.value === '1' ||
      this.kaskoVorversicherung.value === '2') ? true : false;
  }

  get showKaskoschaedenAnzahl() {
    return this.showKaskoschaeden && this.kaskoschaeden.value === 'ja' ? true : false;
  }

  addBmOptionKeineVorversicherung(): void {
    this.bmStufenVorversicherung.set(10, 'Keine Vorversicherung');
  }

  removeBmOptionKeineVorversicherung(): void {
    this.bmStufeVorversicherung.reset();
    this.bmStufenVorversicherung.delete(10);
  }

  setSchadenZeitpunktMinDate(minDate: Date): void {
    const schadenZeitpunktDay = 1;
    this.schadenZeitpunktMinDate = new Date(Date.UTC(minDate.getFullYear() -2 , 9, schadenZeitpunktDay));
  }

  onValueChanged(): void {
    merge(
      this.hdiKfzMotorradVersicherung.valueChanges,
      this.offeneSchaeden.valueChanges,
      this.bmStufeVorversicherung.valueChanges,
      this.kaskoVorversicherung.valueChanges,
      this.kaskoschaeden.valueChanges
    ).subscribe(() => {
      this.toggleEditMode();
    });
    this.hdiKfzMotorradVersicherung.valueChanges.subscribe(() => {
      this.ref.detectChanges();
    });
  }

  setKfzAntrag(kfzAntrag: IKfzAntrag) {
    this.versicherungsbestaetigungComponent.setVersicherungsbestaetigung(kfzAntrag.Versicherungsbestaetigung);
    this.kennzeichen.setValue(kfzAntrag.Produkt.Kennzeichen);
    this.kaskoVorversicherung.setValue(kfzAntrag.Produkt.Risikos.some(x => x.Kasko?.KaskoAbweichendeVorversicherung === true) ? '2' :
      kfzAntrag.Produkt.Haftpflicht.HdiKfzMotorradVersicherung != null ?
        kfzAntrag.Produkt.Haftpflicht.HdiKfzMotorradVersicherung === true ? '1' : '3' : null);
    this.kaskoStornodatumVorvertrag.setValue(kfzAntrag.Produkt.Risikos.find(x => x.Kasko?.StornodatumVorvertrag)?.Kasko.StornodatumVorvertrag);
    this.kaskoschaeden.setValue(kfzAntrag.Produkt.Risikos.some(x => x.Kasko?.Kaskoschaeden === true));
    this.kaskoschaedenAnzahl.setValue(kfzAntrag.Produkt.Risikos.find(x => x.Kasko?.KaskoschaedenAnzahl)?.Kasko.KaskoschaedenAnzahl);
    this.hdiKfzMotorradVersicherung.setValue(kfzAntrag.Produkt.Haftpflicht.HdiPolizzennummer != null ? '1' :
      kfzAntrag.Produkt.Haftpflicht.HdiKfzMotorradVersicherung != null ?
        kfzAntrag.Produkt.Haftpflicht.HdiKfzMotorradVersicherung === true ? '2' : '3' : null);
    this.ref.detectChanges();
    this.hdiPolizzennummer.setValue(kfzAntrag.Produkt.Haftpflicht.HdiPolizzennummer);
    if (kfzAntrag.Produkt.Haftpflicht.Vorversicherung) {
      this.vorversicherungComponent.setVorversicherung(kfzAntrag.Produkt.Haftpflicht.Vorversicherung);
    }
    this.bmStufeVorversicherung.setValue(kfzAntrag.Produkt.Haftpflicht.BmStufeVorversicherung);
    this.bmStufeNullJahre.setValue(kfzAntrag.Produkt.Haftpflicht.BmStufeNullJahre);
    this.offeneSchaeden.setValue(kfzAntrag.Produkt.Haftpflicht.OffeneSchaeden != null ?
      kfzAntrag.Produkt.Haftpflicht.OffeneSchaeden === true ? 'ja' : 'nein' : null);
    this.ref.detectChanges();
    if (kfzAntrag.Produkt.Haftpflicht.FirstSchadenZeitpunkt) {
      this.firstSchadenZeitpunkt.setValue(moment(kfzAntrag.Produkt.Haftpflicht.FirstSchadenZeitpunkt));
    }
    if (kfzAntrag.Produkt.Haftpflicht.SecondSchadenZeitpunkt) {
      this.secondSchadenZeitpunkt.setValue(moment(kfzAntrag.Produkt.Haftpflicht.SecondSchadenZeitpunkt));
    }
    if (kfzAntrag.Produkt.Haftpflicht.ThirdSchadenZeitpunkt) {
      this.thirdSchadenZeitpunkt.setValue(moment(kfzAntrag.Produkt.Haftpflicht.ThirdSchadenZeitpunkt));
    }
    if (kfzAntrag.Produkt.Haftpflicht.StornodatumVorvertrag) {
      this.stornodatumVorvertrag.setValue(moment(kfzAntrag.Produkt.Haftpflicht.StornodatumVorvertrag));
    }
  }

  getKfzAntrag(): IKfzAntrag {
    return {
      Versicherungsbestaetigung: this.versicherungsbestaetigungComponent.getVersicherungsbestaetigung()
    } as IKfzAntrag;
  }
}
